import { Heading, Text } from "@/design-system";
import { cn } from "@/utils";
import type { LegalDocument } from "../content/types";
import { formatLegalDate, readingMinutes } from "../utils";
import { LegalRichText } from "./legalRichText";

type LegalHeroProps = {
  document: LegalDocument;
  /** Sobrescreve o respiro do topo, pensado para o header fixo do site. */
  className?: string;
};

export const LegalHero = ({ document, className }: LegalHeroProps) => (
  <section
    aria-labelledby="legal-title"
    className={cn(
      "mx-auto flex w-full max-w-6xl flex-col items-start gap-5 px-4 pt-32 sm:px-6 md:pt-40 lg:px-8",
      className
    )}
  >
    <Text size="small" tone="brand" weight="semibold">
      {document.eyebrow}
    </Text>
    <Heading
      level={1}
      id="legal-title"
      className="md:text-ds-display max-w-3xl"
    >
      {document.title}
    </Heading>
    <Text size="lead" tone="muted" className="max-w-2xl">
      <LegalRichText text={document.intro} />
    </Text>
    <dl className="text-ds-small text-ds-ink-600 flex flex-wrap gap-x-6 gap-y-2">
      <div className="flex gap-1">
        <dt>Atualizada em</dt>
        <dd className="text-ds-ink-900 font-semibold">
          <time dateTime={document.updatedAt}>
            {formatLegalDate(document.updatedAt)}
          </time>
        </dd>
      </div>
      <div className="flex gap-1">
        <dt>Versão</dt>
        <dd className="text-ds-ink-900 font-semibold">{document.version}</dd>
      </div>
      <div className="flex gap-1">
        <dt className="sr-only">Tempo de leitura</dt>
        <dd className="text-ds-ink-900 font-semibold">
          {readingMinutes(document)} min de leitura
        </dd>
      </div>
    </dl>
  </section>
);
